import { useState, useEffect } from "react"; 
import { jwtFetch } from "./utils/apiClient";
import { useParams, useNavigate } from "react-router-dom";
import Select from "react-select";
import { config } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const SubcategoryEdit = () => {
  const { id_product_subcategory } = useParams();
  const [ categories, setCategories ] = useState(null);
  const [ productCategory, setProductCategory ] = useState(null);
  const [ productSubcategoryName, setProductSubcategoryName ] = useState('');
  const [ productSubcategoryStatus, setProductSubcategoryStatus ] = useState('Active');
  const [ isLoadingSubmit, setIsLoadingSubmit ] = useState(false);
  
  const navigate = useNavigate();

  useEffect(() => {
    getCategories();
  }, []);

  useEffect(() => {
    if (categories) {
      getSubcategory();
    }
  }, [categories]);

  const getCategories = async () => {
    try {
      const requestCategories = {};
      const fetchCategories = await jwtFetch(config.ENDPOINT + 'get/product_category', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestCategories)
      });
      const responseCategories = await fetchCategories.json();
      if (responseCategories.status === 200) {
        for (let i in responseCategories.data) {
          responseCategories.data[i].value = responseCategories.data[i].id_product_category;
          responseCategories.data[i].label = responseCategories.data[i].product_category_name;
        }
        setCategories([...responseCategories.data].sort((a, b) => (a.product_category_name || '').localeCompare(b.product_category_name || '')));
      } else {
        alert(responseCategories.message);
      }
    } catch (error) {
      console.error('Error in getCategories:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }
  
  const getSubcategory = async () => {
    try {
      const requestSubcategory = {
        id_product_subcategory: id_product_subcategory
      };
      const fetchSubcategory = await jwtFetch(config.ENDPOINT + 'get/product_subcategory', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestSubcategory)
      });
      const responseSubcategory = await fetchSubcategory.json();
      if (responseSubcategory.status === 200) {
        setProductSubcategoryName(responseSubcategory.data[0].product_subcategory_name);
        setProductSubcategoryStatus(responseSubcategory.data[0].product_subcategory_status);
        changeCategoryData(responseSubcategory.data[0].product_category_id);
      } else {
        alert(responseSubcategory.message);
      }
    } catch (error) {
      console.error('Error in getSubcategory:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const changeCategoryData = (value) => {
    const category = categories.find(category => category.id_product_category == value);
    setProductCategory(category);
  }

  const submitSubcategoryEdit = async (e) => {
    try {
      e.preventDefault();
      setIsLoadingSubmit(true);
      const requestSubcategoryEdit = {
        "id_product_subcategory": id_product_subcategory,
        "product_category_id": productCategory.value,
        "product_subcategory_name": productSubcategoryName,
        "product_subcategory_status": productSubcategoryStatus,
      }
      const fetchSubcategoryEdit = await jwtFetch(config.ENDPOINT + 'update/product_subcategory', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestSubcategoryEdit)
      });
      const responseSubcategoryEdit = await fetchSubcategoryEdit.json();
      if (responseSubcategoryEdit.status === 200) {
        window.location.href = '/product/category/subcategory/detail/' + id_product_subcategory;
      } else {
        alert(responseSubcategoryEdit.message);
        setIsLoadingSubmit(false);
      }
    } catch (error) {
      console.error('Error in submitSubcategoryEdit:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoadingSubmit(false);
    }
  }
  
  return (
    <div id="subcategory-edit">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar"/></a>
            </div>
            <hr className="m-0"/>
            <Menu active="product"/>
          </div>
          <div className="col-md-10">
            <Header/>
            <hr className="m-0"/>
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="fs-24 mb-3"><button className="btn btn-link" onClick={() => navigate(-1)}><i className="bi bi-arrow-left"/></button> Subcategory Edit</div>
                  <form className="row" onSubmit={(e) => submitSubcategoryEdit(e)}>
                    <div className="col-md-6">
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Category <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <Select value={productCategory} options={categories} placeholder="" onChange={(e) => changeCategoryData(e.value)} required/>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Name <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <input className="form-control" type="text" value={productSubcategoryName} onChange={(e) => setProductSubcategoryName(e.target.value)} required autoFocus/>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-4">
                        <div className="col-md-4">
                          <label>Status <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <div className="form-check form-switch pt-1">
                            <input id="user-active" className="form-check-input" type="checkbox" value="Active" onChange={() => setProductSubcategoryStatus(productSubcategoryStatus === 'Active' ? 'Inactive' : 'Active')} checked={productSubcategoryStatus === 'Active' ? true : false}/>
                            <label htmlFor="user-active" className="form-check-label">{productSubcategoryStatus}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="d-flex justify-content-end mb-4">
                        <button className="btn btn-sm btn-link text-danger" type="button" onClick={() => window.location.href = '/product/category/subcategory/detail/' + id_product_subcategory}>Cancel</button>
                        <button className="btn btn-sm btn-primary ms-2" type="submit" disabled={isLoadingSubmit}>{isLoadingSubmit ? 'Loading...' : 'Update'}</button>
                      </div>
                    </div>
                  </form>
                </section>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubcategoryEdit;


